import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import {
  faPhone,
  faClock,
  faEnvelope,
  faSignInAlt,
  faPowerOff,
} from "@fortawesome/free-solid-svg-icons";

export const navItems = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/housePrice", label: "House Price" },
  { path: "/contact", label: "Contact" },
];

export const infoItems = [
  { icon: faPhone, text: "0300-4516820" },
  { icon: faClock, text: "MON - SUN: 09 AM - 09 PM" },
  {
    icon: faEnvelope,
    text: "ch_imtiazali@yahoo.com",
    link: true,
  },
];

export const socialItems = [
  { icon: faPowerOff, path: "", hide: true },
  { icon: faTwitter, path: "" },
  { icon: faSignInAlt, path: "/dashboard" },
];
